export const mixpanelTrackEvent = (media, asset) => {
    const eventObject = {
        Media: media,
        'Shared Asset': asset
    };

    if (typeof MixpanelWrapper !== 'undefined' && typeof MixpanelWrapper.trackEvent === 'function') {
        MixpanelWrapper.trackEvent('Clicked Social Sharing', eventObject);
    }
};

export default mixpanelTrackEvent;



// WEBPACK FOOTER //
// ./src/utils/mixPanelReporter.js